import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getRentals(eventId, params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get(
    `events/${eventId}/material-rentals?` + parameters
  );
  return data;
}

export async function getRental(eventId, id) {
  const { data } = await axios.get(`events/${eventId}/material-rentals/` + id);
  return data;
}

export async function createRental(eventId, values) {
  const { data } = await axios.post(
    `events/${eventId}/material-rentals`,
    values
  );
  return data;
}

export async function returnRental(eventId, rentalId, values) {
  const { data } = await axios.post(
    `events/${eventId}/material-rentals/${rentalId}/return`,
    values
  );
  return data;
}

export async function updateRental(eventId, id, values) {
  const { data } = await axios.patch(
    `events/${eventId}/material-rentals/` + id,
    values
  );
  return data;
}

export async function deleteRental(eventId, id) {
  const { data } = await axios.delete(
    `events/${eventId}/material-rentals/` + id
  );
  return data;
}
